<template>
  <v-dialog
      v-model="value"
      persistent
      max-width="500"
      >
      <v-card>
          <v-card-title class="text-h5">
              Send Text Message
          </v-card-title>
          <v-card-subtitle>
              {{phoneNumber}}
          </v-card-subtitle>


          <v-card-text>
              <ul
                v-if="item"
              >
                <li v-for="field in fields"
                  :key="`li_${field.id}`"
                >
                {{field.id}}: {{item[field.id]}}
                </li>
              </ul>

              <v-textarea
                  counter
                  label="Reply"
                  v-model="smsReply"
                  rows="3"
                  :maxlength="1000"
                  background-color="grey lighten-3"
              ></v-textarea>

          </v-card-text>
          <v-card-actions>
          <v-checkbox
              v-model="confirm"
              label="Archive"
              v-if="canConfirm"
          ></v-checkbox>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="sendSMS"
              :disabled="!!!smsReply || sending"
          >
              Send
          </v-btn>
          <v-btn
              text
              @click="closeDialog()"
              :disabled="sending"
          >
              Cancel
          </v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>

</template>

<script>


  export default {
    props: {
      value: {
        default: false,
        type: Boolean
      },
      item: {
        type: Object,
        default: () => {}
      }, 
      fields: {
        type: Array,
        default: () => []
      }, 
      fieldId: {
        type: String,
        default: ''
      },       
      phoneNumber: {
        type: String,
        default: ''
      },       
      phoneFieldId: {
        type: String,
        default: ''
      },  
      canConfirm: {
        type: Boolean,
        default: false
      }           
    },
    data: () => ({
      smsReply: '',
      sending: false,
      confirm: false
    }),
    mounted() {
    },
    methods: {
      closeDialog() {
        this.smsReply = ''
        this.sending = false
        this.$emit('input', false)
      },
      async sendSMS() {
        this.sending = true
        console.log('this.phoneFieldId', this.phoneFieldId)
        console.log('confirm', this.confirm )

        let result = await this.$store.dispatch('group/sendGroupPageSms', {message: this.item, text: this.smsReply, fieldId: this.phoneFieldId, confirm: this.confirm})
        


        result.map(r => {
          if (r.id === 'new_item') {
            console.log('r', r)
            let newItem = JSON.parse(r.value)
            console.log('newItem', newItem)

            this.$emit('itemChanged', {item: newItem, confirm: this.confirm})
          }

        })
        this.sending = false
        this.confirm = false
        this.closeDialog()
      },
    },
    computed: {

    }
  }
</script>

